export default __webpack_public_path__ + "static/linkBg4-8af4e1fb1f041d7f2d71e900c122a29a.png";